interface BugsnagEvent {
  severity: string;
  groupingHash: string;
  addMetadata: (section: string, values: Record<string, unknown>) => void;
}

interface WindowWithBugsnag extends Window {
  bugsnagClient: {
    notify: (error: any, onError?: (event: BugsnagEvent) => void) => void;
  };
}

export function bugsnagNotify(error: any, onError?: (event: BugsnagEvent) => void) {
  if (typeof window !== 'undefined' && 'bugsnagClient' in window) {
    (window as unknown as WindowWithBugsnag).bugsnagClient.notify(error, onError);
    return true;
  }
  return false;
}
